
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pipelines/new",
      function () {
        return require("private-next-pages/pipelines/new.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pipelines/new"])
      });
    }
  